import { cleanUpObjRecursive } from "@omni/utils/object.utils";

import { WithdrawalFormRequest } from "@/components/WithdrawalForm/withdrawalForm.types";
import { WithdrawalFormValues } from "@/components/WithdrawalForm/withdrawalFrom.schema";

export const getAddress = ({
    address
}: WithdrawalFormValues): WithdrawalFormRequest["address"] | undefined => {
    if (
        !address?.country ||
        !address?.street ||
        !address?.number ||
        !address?.zipCode ||
        !address?.city
    ) {
        return undefined;
    }

    return cleanUpObjRecursive({
        country: address.country,
        street: address.street,
        number: address.number,
        zipCode: address.zipCode,
        city: address.city,
        box: address.box || undefined
    });
};
